import extendNode from '../extendNode.mjs'
import useCatRootModuleNode from '../_CAT_ROOT_MODULE/useCatRootModuleNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootFm.jsx'
import meta from './metaCatRootFm.mjs'

export default () => {
    const CatRootModuleNode = useCatRootModuleNode()

    return extendNode(CatRootModuleNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            const {prjTypeCode, subTypeCode} = map.data

            if (
                'BCT' === prjTypeCode ||
                'BODA2' === subTypeCode
            ) {
                return /^(BD|UI)$/.test(type)
            }
            else {
                return /^(SF|UI)$/.test(type)
            }
        },

        menuItemsInsertProduct(map, node) {
            const {prjTypeCode, subTypeCode} = map.data

            if (
                'BCT' === prjTypeCode ||
                'BODA2' === subTypeCode
            ) {
                return [
                    {type: 'BD'},
                    {type: 'UI'},
                ]
            }
            else {
                return [
                    {type: 'SF'},
                    {type: 'UI'},
                ]
            }
        },
    })
}
